import React, { useState } from 'react'
import Add from './add'
import Grid from './grid'
import { AccordionWithArrow } from '../../../../components'
import { Wrapper } from './style'
import { consoleLog } from '../../../../util'

const SystemAccessLog = () => {
  const [updatedData, setUpdatedData] = useState(null)

  const updatedDataFunc = (data = []) => {
    consoleLog('data = ', data)
    setUpdatedData(data)
  }

  return (
    <Wrapper>
      <AccordionWithArrow title='System Access Log' expanded={true} accordionstyle='fieldset'>
        <Add onChange={updatedDataFunc} />
        <Grid gridData={updatedData} />
      </AccordionWithArrow>
    </Wrapper>
  )
}

export default SystemAccessLog
